import { Container, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import * as React from "react";
import { useHistory, useParams } from "react-router-dom";
import I18N from "oc-I18N";
import Grid from "@material-ui/core/Grid";
import CustomSelect from "../organisms/CustomSelext";
import ExhibitionDetails from "../organisms/ExhibitionDetails";

export function Booths() {
  const theme = useTheme();
  const history = useHistory();
  const params = useParams();
  const [sizeFilter, setSizeFilter] = React.useState(false);
  const [typeFilter, setTypeFilter] = React.useState(false);
  const [sort, setSort] = React.useState("Recommended");

  const exhibition = APP.richMetadata.metadata.Exhibitions.find(
    (exhi) => exhi.id == (APP.arrangement?.state?.exhibition?.id || params.exhibitionId)
  );
  const boothSet = exhibition?.BoothSet;
  let booths = boothSet ? boothSet?.BoothsForBoothSets.map((bfbs) => bfbs.Booth) : [];

  const sortFilter = [
    {
      Name: "Recommended",
      Label: I18N("Sort:Recommended"),
    },
    {
      Name: "Hot",
      Label: I18N("Sort:Hot"),
    },
    {
      Name: "Price",
      Label: I18N("Sort:Price"),
    },
  ];

  // const addInspirationsToBooths = (boothSet) => {
  //   const inspirations = APP.richMetadata.getInspirationsForBoothsetName(boothSet);
  //   booths = [...booths, ...inspirations];
  // };
  // addInspirationsToBooths(boothSet?.Name);

  const getDefaultArticleForBooth = (booth) => {
    const defaultForm = APP.richMetadata.metadata.FormsForBooths.find(
      (formforbooth) => formforbooth.Booth == booth && formforbooth.Form == booth.Type
    );
    return defaultForm?.Article;
  };

  const handleBoothClick = async (event, booth) => {
    const boothModel = booth;
    APP.arrangement.resetBoothCustomization();
    APP.arrangement.booth.clearInteriors();

    if (!booth.Inspiration) {
      history.push(`/${exhibition.id}/${boothModel.id}/configurator`);
      APP.arrangement.createDefaultArrangement(APP.parseParams(), null);
    } else {
      history.push(`/${exhibition.id}/${boothModel.id}/configurator/${booth.Inspiration}`);
      const configuration = await APP.createConfigurationFromCode(booth.Inspiration);
      APP.arrangement.createDefaultArrangement(APP.parseParams(), configuration);
    }
    APP.dirty();
  };

  // finds all unique Booth Sizes available and sorts them by the first character (3 -> 4 -> 5)
  const boothSizes = _.uniq([
    ...new Set(booths.map((booth) => booth.FormsForBooths?.map((ffb) => ffb.Size.Name)).flat()),
  ])
    .filter((x) => x !== undefined)
    .sort((a, b) => a.localeCompare(b));

  // finds all unique Booth Types available for this Exhibition
  const boothTypes = [...new Set(booths.map((booth) => booth.Sort_Type?.SortName))].filter(
    (x) => x !== undefined
  );
  if (sizeFilter) {
    booths = booths.filter((b) => b.FormsForBooths?.some((d) => d.Size.Name === sizeFilter));
  }
  if (typeFilter) {
    booths = booths.filter(b => b.FormsForBooths.some(f => f.Form.SortName.match(typeFilter, 'i')) )
  }
  // Sorts booths
  switch (sort) {
    case "Hot":
      booths = booths.sort((a, b) => (a.IsHot > b.IsHot ? -1 : 1));
      break;
    case "Price":
      // Sortiert von klein nach groß, wenn kein Preis eingetragen ist (undefined) wird immer ans Ende sortiert
      booths = booths.sort((a, b) =>
        getDefaultArticleForBooth(a)?.Preis < getDefaultArticleForBooth(b)?.Preis ? -1 : 1
      );
      break;
    default:
      // Default is "Recommended"
      booths = booths.sort((a, b) => (a.Recommended > b.Recommended ? -1 : 1));
  }

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", flexGrow: 1, minHeight: "calc(100% - 64px)" }}
    >
      <Container sx={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <ExhibitionDetails exhibition={exhibition} />
      </Container>
      <Box
        sx={{
          backgroundColor: "#F5F6FA",
          w: "100%",
          borderTop: "1px solid #E2E2E2",
          height: "100%",
          flex: "1 1 auto",
        }}
      >
        <Container>
          <Box sx={{ padding: "22px 2px 0 2px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: "14px" }}>
              <Box sx={{ display: "flex" }}>
                <FormControl sx={{ mr: "8px" }} className={'booth-filter'}>
                  <CustomSelect
                    value={sizeFilter}
                    options={boothSizes}
                    onChangeFn={setSizeFilter}
                    placement={"bottom-start"}
                    label={I18N("Size Filter")}
                  />
                </FormControl>

                <FormControl className={'booth-filter'}>
                  <CustomSelect
                    value={typeFilter}
                    options={boothTypes}
                    onChangeFn={setTypeFilter}
                    placement={"bottom-start"}
                    label={I18N("Type Filter")}
                  />
                </FormControl>
              </Box>

              <FormControl className={'booth-filter'}>
                <CustomSelect
                  value={sort}
                  options={sortFilter}
                  onChangeFn={setSort}
                  placement={"bottom-end"}
                />
              </FormControl>
            </Box>

            <Grid container spacing={2}>
              {booths.length > 0 ? (
                booths.map((item) => (
                  <Grid item key={item.Displayed_Name + '_' + item.id || item.Code} xs={12} sm={6} md={4} lg={3}>
                    <Box
                      onClick={(event) => handleBoothClick(event, item)}
                      sx={{
                        position: "relative",
                        width: "100%",
                        padding: "10px 13px",
                        border: "1px solid #E2E2E2",
                        borderRadius: "10px",
                        height: "100%",
                        backgroundColor: "#fff",
                        cursor: "pointer",
                        transition: "all 0.3s",
                        overflow: "hidden",
                        "&:hover": {
                          boxShadow: 4,
                          transform: "translate(0,-5px)",
                          img: {
                            transform: "scale(1.2)",
                          },
                        },
                      }}
                    >
                      {(item.FormsForBooths?.filter((b) => b.Default)[0]?.Thumbnail ||
                        item.GeneratedThumbnail) && (
                        <Box
                          sx={{
                            overflow: "hidden",
                            width: "100%",
                            height: "150px",
                            borderRadius: "10px",
                            marginBottom: 2,
                          }}
                        >
                          <img
                            src={`${
                              item.GeneratedThumbnail ||
                              item.FormsForBooths.filter((b) => b.Default)[0].Thumbnail
                            }`}
                            alt={item.Displayed_Name}
                            style={{
                              borderRadius: "10px",
                              width: "100%",
                              height: "150px",
                              objectFit: "cover",
                              overflow: "hidden",
                              transition: "all 0.3s",
                            }}
                          />
                        </Box>
                      )}
                      <Typography
                        gutterBottom
                        variant="body1"
                        component="div"
                        sx={{ fontWeight: 700, color: "#3A415A" }}
                      >
                        {item.Displayed_Name || item.Code}
                      </Typography>
                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography variant="small" sx={{ color: "#939599", fontSize: "14px" }}>
                          {_.uniq(item.FormsForBooths?.map((b) => b.Size?.Label)).join(", ")}
                        </Typography>
                        <Typography
                          variant="body1"
                          component="div"
                          sx={{ fontWeight: 700, color: "#3A415A" }}
                        >
                          {getDefaultArticleForBooth(item)
                            ? APP.formatter.format(getDefaultArticleForBooth(item).Preis)
                            : ""}
                        </Typography>
                      </Box>
                      {item.IsHot && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: "18px",
                            left: 0,
                            background: "linear-gradient(180deg, #E94452 0%, #EC622F 100%)",
                            borderRadius: "0 4px 4px 0",
                            padding: "5px",
                            width: "70px",
                            textAlign: "center",
                          }}
                        >
                          <Typography variant="body1" sx={{ color: "#fff", fontWeight: "700" }}>
                            {I18N("HotBanner")}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                ))
              ) : (
                <p>{I18N("No Booths found")}</p>
              )}
            </Grid>
          </Box>
          <Box
            sx={{
              height: "50px",
              [theme.breakpoints.up("lg")]: {
                height: "59px",
              },
            }}
          />
        </Container>
      </Box>
    </Box>
  );
}
